// Role gating for the Apple delegated-onboarding console. Two named lists so widening access is a
// one-line edit here rather than a hunt through collection definitions — the same shape as
// `apple_grant_status.roles.ts`, whose `hasAnyRole` this reuses rather than re-implementing.
//
// ⚠️ THESE ARE A UI CONVENTION, NOT AN ENFORCED CONTROL, and nothing here should be read as
// otherwise. The Firestore rules for `apple_delegated_onboarding` allow any authenticated principal
// to write (design §3.1), and `services/auth.ts:25` admits any `@getdeardoc.com` address WITHOUT
// calling `setExtra`, so a legitimately signed-in user can hold no roles at all. What makes this
// safe is that the backend re-validates every input and re-checks every readiness gate server-side
// before it calls Apple — an accepted, documented cost, not an oversight this file mitigates.

export { hasAnyRole } from "./apple_grant_status.roles";

/** Who can open the console and read a practice's onboarding progress. */
export const ONBOARDING_VIEW_ROLES = ["admin", "csm"] as const;

/**
 * Who can press a queue button or re-open a parked step.
 *
 * Narrower than viewing on purpose: every one of these buttons ends in a write to a real client's
 * public Apple presence, and three of the four steps mint a resource Apple gives us no way to
 * delete. Editing the `input` fields is governed by the collection's `edit` permission and is
 * deliberately the wider of the two — filling a form in is harmless until someone queues it.
 */
export const ONBOARDING_QUEUE_ROLES = ["admin"] as const;
